import { RESTClientConfig } from 'rest-client';

import {
  getAppName,
  getAppVersion,
  getDeviceType,
} from '@app/modules/shared/utils/app-data.utils';
import { environment } from '@env/environment';

export function APIConfigFactory(): RESTClientConfig {
  return new RESTClientConfig({
    apiUrl: environment.API,
    pciApiUrl: environment.PCIAPI,
    production: environment.production,
    appVersion: getAppVersion(),
    appName: getAppName(),
    deviceType: getDeviceType(),
    useCookies: false,
    tokenKey: 'auth_token',
    versionNumber: environment.VERSION,
  });
}
